import React, { useEffect, useState } from "react";
import { Tab } from "react-bootstrap";
import { Tabs } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import "../../Profile/companyProfile.css";
import { toast } from "react-toastify";
import { toastProperties } from "../../../commons/Toast/Toaster";
import NodataFound from "../../../commons/Toast/noDataFound";
import { useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import RoleBasedApiPermissions from "./roleBasedApiPermissions";
import { Card } from "react-bootstrap";

const UserProfile = () => {
 const [myProfileDetails, setMyProfileDetails] = useState([]);
 const [isEditProfile, setIsEditProfile] = useState(false);
 const [capacityList, setCapacityList] = useState(null);
 const [key, setKey] = useState("Details1");
 const [logsList, setLogsList] = useState(null);

 let userDetails = JSON.parse(localStorage.getItem("UserDetails"));
 const handleSelect = (key) => {
  setKey(key);
 };
 const getMyProfileDetails = (id) => {
  // editProfileService.getMyProfileDetails(id).then((response) => {
  //     if (response?.data?.code === 200) {
  //         setMyProfileDetails(response?.data?.data)
  //     }
  // })
 };

 const handleAccountStatus = (accStatus) => {
  // analystService.updateAccountStatus(accStatus, userDetails?.companyId).then((response) => {
  //     if (response?.data?.code === 200) {
  //         toast.success(response?.data?.message, toastProperties);
  //         getMyProfileDetails(userDetails?.userId)
  //     }
  // }).catch(error => console.error("Api call Error:", error))
 };

 const handleOpenEditProfileModal = () => {
  setIsEditProfile(true);
 };

 const handleCloseEditProfileModal = () => {
  setIsEditProfile(false);
 };

 const handleCapacityListing = (key) => {
  // if (key === 'CapacityListing') {
  //     if (userDetails?.accountType === 'GENERATOR') {
  //         analystService.getAllCapacityListingByPlantId(myProfileDetails?.companyResponse?.plant?.id).then((response) => {
  //             if (response?.data?.code === 200) {
  //                 setCapacityList(response?.data?.data)
  //             }
  //         }).catch(error => console.error("Api call Error:", error))
  //     }
  //     if (userDetails?.accountType === 'CONSUMER') {
  //         analystService.getAllCapacityListingByConsumerId(myProfileDetails?.companyResponse?.consumer?.id).then((response) => {
  //             if (response?.data?.code === 200) {
  //                 setCapacityList(response?.data?.data)
  //             }
  //         }).catch(error => console.error("Api call Error:", error))
  //     }
  // }
 };
 const getLogsLIst = () => {
  // logsService.getLogsList().then((response) => {
  //     if (response?.data?.code === 200) {
  //         setLogsList(response?.data?.data)
  //     }
  // }).catch((error) => { console.log("Api Error:", error) })
 };
 useEffect(() => {
  if (key === "MyLogs") {
   getLogsLIst();
  } else {
   handleCapacityListing(key);
  }
 }, [key]);

 useEffect(() => {
  getMyProfileDetails(userDetails?.userId);
 }, []);
 const configKey = useSelector((state) => state?.sessionState?.connectionName);
 const [isModel, setIsModel] = useState(false);

 const handleEditClick = (item) => {
  setIsModel(item);
 };
 const handleAddNewSlot = (e) => {
  setIsModel(true);
 };
 return (
  <>
   <div className="container my-4">
    <div className="company-profile-btn-group justify-content-between my-4">
     <Link to={"/admin_comp_dashboard"}>
      <button className="btn btn-secondary">
       <i className="fa fa-chevron-left"></i> Back to Dashboard
      </button>
     </Link>
     <button type="button" className="btn btn-login" onClick={handleAddNewSlot}>
      Add New Capacity
     </button>
    </div>
    <Card>
     <Card.Body className="p-4">
      <div className="setting-section-nev">
       <Tabs
        variant="nav"
        defaultActiveKey="Details1"
        id="controlled-tab-example"
        onSelect={(e) => handleSelect(e)}
       >
        <Tab eventKey="Details1" title="Company Information">
         <div className="compnay_tab_flex">
          <div className="div-table" style={{ marginRight: "20%" }}>
           <div className="div-row">
            <div className="div-cell">User Name</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.userResponse?.userName}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Email</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.userResponse?.email}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Phone Number</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.userResponse?.phone}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Credit Rating</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.creditRating?.rating}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Credit Rating Year</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.creditRatingYear}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Credit Rating Agency</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.creditRatingAgency}
            </div>
           </div>
           <div className="div-cell div-cell-black">Bank Details</div>
           <div className="div-row">
            <div className="div-cell">Name and Branch Address</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.bankAccounts[0]?.name}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Account Number</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.bankAccounts[0]?.accNo}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Ifsc Code</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.bankAccounts[0]?.ifsc}
            </div>
           </div>
          </div>
          <div className="div-table">
           <div className="div-cell div-cell-black">Office Address</div>
           <div className="div-row">
            <div className="div-cell">Registered Address</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.addresses[0]?.address}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">State</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.addresses[0]?.stateUt}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">City</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.addresses[0]?.city}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Pin Code</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.addresses[0]?.pin}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Telephone</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.addresses[0]?.tel}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Email</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.addresses[0]?.email}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Fax Number</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.addresses[0]?.fax}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Name Of Contact Person(s)</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.addresses[0]?.contactPersons?.join(
              ", "
             )}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Mobile Number</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.addresses[0]?.mob}
            </div>
           </div>
           <div className="div-cell div-cell-black">Correspondence Address</div>
           <div className="div-row">
            <div className="div-cell">Address</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.addresses[1]?.address}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">State</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.addresses[1]?.stateUt}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">City</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.addresses[1]?.city}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Pin Code</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.addresses[1]?.pin}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Telephone</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.addresses[1]?.tel}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Email</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.addresses[1]?.email}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Fax Number</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.addresses[1]?.fax}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Name Of Contact Person(s)</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.addresses[1]?.contactPersons?.join(
              ", "
             )}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Mobile Number</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.addresses[1]?.mob}
            </div>
           </div>
          </div>
         </div>
        </Tab>
        <Tab eventKey="Details2" title={"Plant Details"}>
         <div className="compnay_tab_flex">
          <div className="div-table" style={{ marginRight: "20%" }}>
           <div className="div-row">
            <div className="div-cell">Generating Type</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.plant?.energyType?.genType}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Energy Type</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.plant?.energyType?.type}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Plant Specification</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">NA</div>
           </div>
           <div className="div-row">
            <div className="div-cell">Project Id</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.plant?.projectId}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Install Capacity</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.plant?.installedCap
              ? myProfileDetails?.companyResponse?.plant?.installedCap
              : "NA"}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Control Area</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.plant?.controlArea?.type}
            </div>
           </div>
          </div>
          <div className="div-table">
           <div className="div-row">
            <div className="div-cell">Point Of Injection</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.plant?.poi?.value}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Poi Location</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.plant?.poiLocation}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Region</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.plant?.region}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">State</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.plant?.stateUt}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Discom</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.plant?.discom?.acronym}
            </div>
           </div>
           <div className="div-row">
            <div className="div-cell">Voltage Level at Discom</div>
            <div className="div-cell">:</div>
            <div className="div-cell div-cell-black">
             {myProfileDetails?.companyResponse?.plant?.discomVoltage}
            </div>
           </div>
          </div>
         </div>
        </Tab>
        {/* <Tab eventKey="Details2" title={"Consumer Details"}>
        <div className="div-table">
         <div className="div-row">
          <div className="div-cell">Maximum Capacity Of Drawal</div>
          <div className="div-cell">:</div>
          <div className="div-cell div-cell-black">
           {myProfileDetails?.companyResponse?.consumer?.maxCapDrawl
            ? myProfileDetails?.companyResponse?.consumer?.maxCapDrawl
            : "NA"}
          </div>
         </div>
         <div className="div-row">
          <div className="div-cell">Region</div>
          <div className="div-cell">:</div>
          <div className="div-cell div-cell-black">
           {myProfileDetails?.companyResponse?.consumer?.region
            ? myProfileDetails?.companyResponse?.consumer?.region
            : "NA"}
          </div>
         </div>
         <div className="div-row">
          <div className="div-cell">State</div>
          <div className="div-cell">:</div>
          <div className="div-cell div-cell-black">
           {myProfileDetails?.companyResponse?.consumer?.stateUt
            ? myProfileDetails?.companyResponse?.consumer?.stateUt
            : "NA"}
          </div>
         </div>
         <div className="div-row">
          <div className="div-cell">Point of Drawal</div>
          <div className="div-cell">:</div>
          <div className="div-cell div-cell-black">
           {myProfileDetails?.companyResponse?.consumer?.pod?.value
            ? myProfileDetails?.companyResponse?.consumer?.pod?.value
            : "NA"}
          </div>
         </div>
         <div className="div-row">
          <div className="div-cell">Consumer Specification</div>
          <div className="div-cell">:</div>
          <div className="div-cell div-cell-black">
           {myProfileDetails?.companyResponse?.consumer?.specification?.name
            ? myProfileDetails?.companyResponse?.consumer?.specification?.name
            : "NA"}
          </div>
         </div>
         <div className="div-row">
          <div className="div-cell">Discom</div>
          <div className="div-cell">:</div>
          <div className="div-cell div-cell-black">
           {myProfileDetails?.companyResponse?.consumer?.discom?.discom
            ? myProfileDetails?.companyResponse?.consumer?.discom?.discom
            : "NA"}
          </div>
         </div>
         <div className="div-row">
          <div className="div-cell">Discom Voltage Level</div>
          <div className="div-cell">:</div>
          <div className="div-cell div-cell-black">
           {myProfileDetails?.companyResponse?.consumer?.discomVoltage}
          </div>
         </div>
        </div>
       </Tab> */}
        <Tab eventKey="Details3" title={"Documents"}>
         <NodataFound />
        </Tab>
        <Tab
         eventKey={"CapacityListing"}
         title="CapacityListing"
         className="table-scrollY"
        >
         <div className="text-center">
          <NodataFound />
         </div>
        </Tab>
        <Tab eventKey={"MyLogs"} title="User Logs" className="table-scrollY">
         <div className="text-center">
          <NodataFound />
         </div>
        </Tab>
        <Tab eventKey={"UserPermissions"} title="User Permissions">
         <RoleBasedApiPermissions />
        </Tab>
       </Tabs>
      </div>
     </Card.Body>
    </Card>
   </div>
  </>
 );
};

export default UserProfile;
